import queryClient from "single-spa/react-app/query-client";

import { createCompanyAnalysisQueryClient } from "./factory";
import type { ICompanyAnalysisQueryClient } from "./types";

export const companyAnalysisQueryClient: ICompanyAnalysisQueryClient =
    createCompanyAnalysisQueryClient({ queryClient });
